<template>
  <v-card>
    <input
      ref="thumbnail-uploader"
      type="file"
      class="d-none"
      accept=".jpg, .jpeg, .png, .webp"
      @change="onFileChanged"
    />
    <div class="pa-4">
      <div class="d-flex justify-space-between align-center">
        <h3 class="text">Thông tin cơ bản</h3>
        <v-btn outlined color="#0D47A1" @click="() => $refs['edit-popup'].openDialog(event)">
          Sửa
        </v-btn>
      </div>
      <div class="mt-2">
        <div class="d-flex">
          <div class="text title-info">Ảnh đại diện</div>
          <div :key="thumbnailChangeKey">
            <img
              v-if="eventThumbnail"
              :src="eventThumbnail"
              style="width: 200px; height: 200px; object-fit: cover"
              class="mb-2"
            />
            <div
              v-else
              style="height: 200px; width: 200px; background-color: lightgrey"
              class="d-flex align-center justify-center"
              title="Chưa có ảnh đại diện"
            >
              <v-icon color="white">mdi-image-area</v-icon>
            </div>
          </div>
          <div class="ml-2">
            <v-btn outlined color="primary" @click="onTriggerUpload">Đổi ảnh đại diện</v-btn>
          </div>
        </div>
        <div class="d-flex">
          <div class="text title-info">Tiêu đề</div>
          <div class="text">{{ event.title }}</div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Mô tả</div>
          <div class="text">
            {{ event.description }}
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Ngày diễn ra</div>
          <div class="text">{{ event.from | ddmmyyyy }} - {{ event.to | ddmmyyyy }}</div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Trạng thái hiển thị</div>
          <div class="text">
            <v-chip :color="event.isPublished | eventStatusColor" small class="white--text">
              {{ event.isPublished | isPublishedText }}
            </v-chip>
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Trạng thái đăng ký</div>
          <div class="text">
            <v-chip :color="event.isOpenRegistration | eventStatusColor" small class="white--text">
              {{ event.isOpenRegistration | isOpenRegistrationText }}
            </v-chip>
          </div>
        </div>
        <div class="d-flex mt-4" v-if="event.registrationDeadline">
          <div class="text title-info">Trạng thái hết hạn</div>
          <div class="text">
            <v-chip :color="event.isExpired | eventExpiredColor" small class="white--text">
              {{ event.isExpired | eventIsExpiredText }}
            </v-chip>
          </div>
        </div>
        <div class="d-flex mt-4" v-if="event.registrationDeadline">
          <div class="text title-info">Hạn đăng ký</div>
          <div class="d-flex flex-column">
            <div class="text">{{ event.registrationDeadline | ddmmyyyy }}</div>
            <div class="grey--text">Khi quá hạn đăng ký, trạng thái đăng ký sẽ tự động chuyển thành "Đóng đăng ký"</div>
          </div>
        </div>
        <div class="d-flex mt-4">
          <div class="text title-info">Áp dụng cho</div>
          <div class="text">
            {{ event.appliedType | appliedTypeText }}
            <span>({{ event.appliedForGrades }}, {{ event.appliedForDepartments }})</span>
          </div>
        </div>
      </div>
    </div>
    <EventEditDialog ref="edit-popup" />
  </v-card>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import EventEditDialog from './EventEditDialog.vue'
import helpers from '../helpers.js'
import {get} from 'lodash'
import moment from 'moment'

export default {
  components: {EventEditDialog},
  data: () => ({isSelecting: false, thumbnailChangeKey: Date.now()}),
  computed: {
    ...mapGetters({event: 'events/getItem', thumbnail: 'events/getThumbnail'}),
    eventThumbnail() {
      if (this.thumbnail) return this.thumbnail
      return get(this.event, 'thumbnail', '')
    }
  },
  methods: {
    ...mapActions({uploadThumbnail: 'events/uploadThumbnail', updateEvent: 'events/update'}),
    onTriggerUpload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        {once: true}
      )
      this.$refs['thumbnail-uploader'].click()
    },
    async onFileChanged(e) {
      const file = e.target.files[0]
      try {
        this.$loading.active = true
        const formData = new FormData()
        formData.append('files', file)
        formData.append('refId', this.event.id)
        formData.append('ref', 'event')
        formData.append('field', 'thumbnailObj')
        const thumbnailObj = await this.uploadThumbnail(formData)
        await this.updateEvent({
          id: this.event.id,
          thumbnailObj: get(thumbnailObj, 'id'),
          thumbnail: get(thumbnailObj, 'url', '')
        })
        this.thumbnailChangeKey = Date.now()
        this.$alert.success('Tải ảnh đại diện thành công')
      } catch (error) {
        this.$alert.error('Tải ảnh đại diện thất bại...', error)
      } finally {
        this.$loading.active = false
      }
    }
  },
  filters: {
    isOpenRegistrationText(val) {
      return val ? 'Đang mở' : 'Đã đóng'
    },
    eventStatusColor(val) {
      return val ? 'green' : 'grey'
    },
    isPublishedText(val) {
      return val ? 'Xuất bản' : 'Chưa xuất bản'
    },
    eventExpiredColor(val) {
      return val ? 'red' : 'green'
    },
    eventIsExpiredText(val) {
      return val ? 'Hết hạn' : 'Còn hạn'
    },
    appliedTypeText(val) {
      return helpers.APPLIED_TYPE[val]
    },
    appliedForGradesTitle(val) {
      if (Array.isArray(val) && val.length) {
        return `(${val.map(x => x.title).join(', ')})`
      }
      return ''
    },
    ddmmyyyy(val) {
      return val ? moment(val).format('DD/MM/YYYY') : ''
    }
  }
}
</script>
<style lang="scss" scoped>
.title-info {
  min-width: 170px;
}
</style>
